<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-users"></i>
          Group Information
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Group</a>
          </li>
      </ul>
    </div>
    <b-tabs v-model="index">
      <b-tab title="Summary">
        <b-card>
          <!-- <div slot="header">
            <strong>Group Information</strong>
            <small>User : {{model.count || 0}}</small>
            <span class="float-right">Group Created Time : {{model.created_at | datetime}}</span>
          </div> -->
          <b-row class="mb-2">
            <b-col md="9" class="col-form-label">
              Summary
              <strong class="font_12 text-primary">User : {{model.count}} </strong>
            </b-col>
            <b-col class="text-right">
              Group Created Time : {{model.created_at | datetime}}
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              Group Service Type
            </b-col>
            <b-col>
              <b-badge pill  :variant="model.service == 'Basic' ? 'info' : 'success'"> {{model.service}} </b-badge>
            </b-col>
            <b-col md="2" class="col-form-label">
              Partner(To complain or issue)
            </b-col>
            <b-col>
              <b-input type="text" v-if="model && model.partner" v-model="model.partner.username" :disabled="true" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              Group Name
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.groupname" :plaintext="lock"></b-input>
            </b-col>
            <b-col md="2" class="col-form-label">
              User
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.count" :disabled="true" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="2" class="col-form-label">
              Group Address
            </b-col>
            <b-col>
              <b-input type="text" v-model="model.address" :plaintext="lock"></b-input>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
              <template>
                <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Modify </b-button>
              </template>
            </template>
            <template v-else>
              <b-button class="btn-add" size="sm" variant="success" @click="save"> Save </b-button>
              <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
            </template>
        </b-card>
      </b-tab>
      <!-- security policy -->
      <b-tab title="Security Policy">
        <b-card>
          <b-row>
            <b-col class="title">
              Security Policy
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              Password failed Count
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input>
            </b-col>
            <b-col md="2" class="col-form-label">
              Block time(Min)
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label">
              Password Min length
            </b-col>
            <b-col class="col-form-label" md="4">
              <b-input type="number" v-model="model.security_policy.password_min_len" :disabled="lock"></b-input>
            </b-col>
            <!-- <b-col md="2" class="col-form-label">
              Block time(Min)
            </b-col>
            <b-col class="col-form-label">
              <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
            </b-col> -->
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              Password Use Alphabet
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="password require alphabet, ex) abcdef....">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_alphabet" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="2" class="col-form-label">
              Password Use Spacial
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="password require Spacial, ex) !@#$%&*()_+-=">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_number" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label">
              Password Use Number
            </b-col>
            <b-col class="col-form-label">
              <!-- <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="password require Number, ex) 0123456789">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.security_policy.password_use_spacial" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr>
          <!-- <b-row>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="Password Fail Count Threshold, default is 5 on system">
                <label for="ph_lock_count">Password failed Count</label>
                <b-input type="number" v-model="model.security_policy.account_lock_count" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="when failed too many logins, default is 5 min on system">
                <label for="ph_lock_time">Block time(Min)</label>
                <b-input type="number" v-model="model.security_policy.account_lock_time" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group v-b-tooltip.hover title="require min length">
                <label for="ph_password_min_len">Password Min length</label>
                <b-input type="number" v-model="model.security_policy.password_min_len" :disabled="lock"></b-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr> -->
          <!-- <b-row>
            <b-col md="4">
              <b-form-group label="Password Use Alphabet" label-for="ph_password_use_alphabet" v-b-tooltip.hover title="password require alphabet, ex) abcdef....">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_alphabet" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Password Use Spacial" label-for="ph_password_use_number" v-b-tooltip.hover title="password require Spacial, ex) !@#$%&*()_+-=">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_number" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Password Use Number" label-for="ph_password_use_spacial" v-b-tooltip.hover title="password require Number, ex) 0123456789">
                <c-switch color="info" label size="sm" v-model="model.security_policy.password_use_spacial" :disabled="lock" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr> -->
          <b-row>
            <b-col md="6" class="col-form-label">
              Custom Account Login Session Timeout (Default count : 300 Sec)
              <h5>The logout timer starts after 5 minutes.</h5>
            </b-col>
            <b-col md="2">
              <div class="input-group">
                <b-input type="number" class="form-control" v-if="model && model.security_policy" :disabled="lock" v-model="model.security_policy.timeout" ></b-input>
                <div class="input-group-append">
                    <button :disabled="true" class="btn btn-sm btn-outline-secondary" type="button">Second</button>
                </div>
              </div>

              <!-- <div class="input-group">
                <input type="text" class="form-control" name="Threshold" id="Threshold" value="300" readonly>
                <div class="input-group-append">
                  <b-btn class="btn btn-outline-secondary">Second</b-btn>
                </div>
              </div> -->
              <!-- <b-input-group size="sm">
                <b-input type="number" v-if="model && model.security_policy" :disabled="lock" v-model="model.security_policy.timeout" ></b-input>
                <b-input-group-append>
                  <b-btn variant="outline-secondary">Second</b-btn>
                </b-input-group-append>
              </b-input-group> -->
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-2">
            <b-col md="12" class="strong text-danger text-center">
              * Allow IP : The settings in the group apply to all accounts in the group
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <ip-list
                type="account"
                comment="The IP Access Control Policy of the Group comes first, followed by the User-specific IP Access Control Policy."
                :lock="lock"
                :press="false"
                :show_button="false"
                :ip_list="model.allow_ip_account || []"
                @add="ip_add"
                @save="save"
                @remove="ip_remove"
                @clear="ip_clear">
              </ip-list>
            </b-col>
          </b-row>
          <!-- <hr> -->
          <!-- <hr> -->
          <b-row class="mb-2">
            <b-col>
              <ip-list
                type="agent"
                comment="IP access control is applied when the agent is installed If you don't have one, you can install it anywhere, but we recommend it."
                :lock="lock"
                :press="false"
                :show_button="false"
                :ip_list="model.allow_ip_agent || []"
                @add="ip_add"
                @save="save"
                @remove="ip_remove"
                @clear="ip_clear">
              </ip-list>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
            <template>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Modify </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> Save </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
          </template>
        </b-card>
      </b-tab>
      <!-- setting -->
      <b-tab title="Setting">
        <b-card>
          <b-row>
            <b-col class="title">
              Setting
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label">
              Allow Email
            </b-col>
            <b-col md="4">
              <!-- <b-form-group label="" label-for="ph_allow_email" > -->
                <!-- <c-switch color="info" label size="sm" v-model="model.allow_mail" :disabled="lock" /> -->
                <div class="checkbox-switch" v-b-tooltip.hover title="Allow security alert by email, default is on">
                  <input type="checkbox" class="input-checkbox" v-model="model.allow_mail" :disabled="lock">
                  <div class="checkbox-animate" :class="{ disabled : lock }">
                      <span class="checkbox-off">OFF</span>
                      <span class="checkbox-on">ON</span>
                  </div>
                </div>
              <!-- </b-form-group> -->
            </b-col>
            <b-col class="title" md="2">
              Single Login
            </b-col>
            <b-col>
              <!-- <b-form-group label="Single Login" label-for="ph_single_login" v-b-tooltip.hover title="only one login allow, default is off">
                <c-switch color="info" label size="sm" v-model="model.single_login" :disabled="lock" />
              </b-form-group> -->
              <div class="checkbox-switch" v-b-tooltip.hover title="only one login allow, default is off">
                <input type="checkbox" class="input-checkbox" v-model="model.single_login" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="title_sub">
                Email CC
                <h6>You can add a mail address to the detection-related information mail reception.</h6>
              </div>
              <b-form-textarea class="form-control" ref="email_cc_list" :rows="model && model.syslog && model.email_cc_list ? model.syslog.length + 2 : 2" max-rows="10" v-model="model.email_cc_list" :plaintext="lock"></b-form-textarea>
              <!-- <b-row>
                <p>You can add a mail address to the detection-related information mail reception</p>

              </b-row> -->
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col>
              <div class="title_sub">
                Syslog <span class="font_13" style="cursor: pointer;" @click="modal.explain = true">(what is syslog format ?)</span>

                <button type="button" class="btn btn-sm btn-insert" @click="modal.explain = true">
                  <span class="font_14 text-info">
                      <i class="fas fa-question-circle"></i>
                  </span>
                </button>
                <h6>You can send the generated logs remotely. Mainly used for connection with the control center.</h6>
              </div>
              <b-form-textarea class="form-control" ref="syslog_list" :rows="model && model.syslog && model.syslog_list ? model.syslog.length + 4 : 4" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
              <!-- <b-row>
                <p>You can add a mail address to the detection-related information mail reception</p>

              </b-row> -->
            </b-col>
            <!-- <b-col md="12">
              <b-form-group>
                <label for="ph_syslog" v-b-tooltip.hover title="Enter a syslog server ip, ex) 192.168.0.100, 192.168.0.100:511 ">
                  <h4>
                    Syslog <small style="cursor: pointer;" @click="modal.explain = true">(what is syslog format ?)</small>
                  </h4>
                  <span>You can send the generated logs remotely. Mainly used for connection with the control center.</span>
                </label>
                <hr>
                <b-form-textarea style="background-color:#f0f3f5;" ref="syslog_list" :rows="model && model.syslog && model.syslog_list ? model.syslog.length + 4 : 4" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
              </b-form-group>
            </b-col> -->
          </b-row>
          <hr>
          <b-row>
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
            <!-- 알림 종류 -->
            <b-col md="2" class="col-form-label mt-4">
              WEBCastle Mode
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-3">Block</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_mode_block" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub">Detection</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_mode_detect" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <!-- <b-col>
              <b-form-group label="">
                <b-form-checkbox style="display:inline-block;" class="mr-5" :disabled="lock" switch v-model="syslog_setting.is_allow_mode_block" >Block</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-5" :disabled="lock" switch v-model="syslog_setting.is_allow_mode_detect" >Detection</b-form-checkbox>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="8">
              <b-form-group label="WEBCastle Severity">
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_emergency" >Emergency</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_alert" >Alert</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_critical" >Critical</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_error" >Error</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_warning" >Warning</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_info" >Info</b-form-checkbox>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
          </b-row>
          <b-row>
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
            <!-- 알림 종류 -->
            <b-col md="2" class="col-form-label mt-4">
              WEBCastle Severity
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub">Emergency</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_emergency" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-3">Alert</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_alert" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-2">Critical</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_critical" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-3">Error</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_error" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-1">Warning</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_warning" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="1" style="min-width: 120px;">
              <p class="title_sub ml-4">Info</p>
              <div class="checkbox-switch" v-b-tooltip.hover title="">
                <input type="checkbox" class="input-checkbox" v-model="syslog_setting.is_allow_severity_info" :disabled="lock">
                <div class="checkbox-animate" :class="{ disabled : lock }">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <!-- <b-col md="8">
              <b-form-group label="WEBCastle Severity">
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_emergency" >Emergency</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_alert" >Alert</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_critical" >Critical</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_error" >Error</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_warning" >Warning</b-form-checkbox>
                <b-form-checkbox style="display:inline-block;" class="mr-3" switch :disabled="lock" v-model="syslog_setting.is_allow_severity_info" >Info</b-form-checkbox>
              </b-form-group>
            </b-col> -->
            <!-- <b-col md="1" style="min-width: 120px;">
            </b-col> -->
          </b-row>
          <hr>
          <template v-if="lock">
            <template>
              <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Modify </b-button>
            </template>
          </template>
          <template v-else>
            <b-button class="btn-add" size="sm" variant="success" @click="save"> Save </b-button>
            <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
          </template>
        </b-card>
      </b-tab>
      <!-- 멤버쉽(구독정보) 해지 -->
      <b-tab title="Membership"
        v-if="auth && auth.profile && auth.profile.permissions && auth.profile.permissions.toUpperCase() == 'OWNER' && auth.license && !auth.license.onPremise"
        @click="signout_status"
      >
        <b-row>
          <b-col md="12">
            <h4>
              <center>Subsctiptoin Status :
                <b-badge  :variant="status.all_bill_pay && status.processing ? (status.approve ? 'danger' : 'warning') : 'success'">
                  {{status.all_bill_pay && status.processing ? (status.approve ? 'End of service' : 'Stoped') : 'Using'}}
                </b-badge>
              </center>
            </h4>
          </b-col>
        </b-row>
        <hr>
        <div>
          <b-jumbotron>
            <!-- <b-button class="text-left" :disabled="status.all_bill_pay" variant="success" href="#" @click="request_billing">
              <del v-if="status.all_bill_pay">STEP.1 Request to Billing this month.</del>
              <span v-else>STEP.1 Request to Billing this months.</span>
            </b-button> -->
            <!-- <span v-if="status.all_bill_pay">✔️ Clear</span>
            <br>
            <br> -->
            <!-- move to billing -->
            <!-- <h4 class="lead">* Make sure you don't have any outstanding payments</h4>
            <h4 class="lead">* Go to <a href="#" @click="$router.push({ name : 'billing' })">Billing</a></h4> -->
            <!-- <hr> -->
            <b-button class="text-left" variant="warning" :disabled="status.all_bill_pay && status.processing" href="#" @click="signout_stop">
              <del v-if="status.all_bill_pay && status.processing">STEP1. Request to stop and this month billing</del>
              <span v-else>STEP.1 Request stop to using service and check this month billing</span>
            </b-button>
            <span v-if="status.all_bill_pay && status.processing">✔️ Clear</span>
            <br>
            <br>
            <!-- 중지 요청해도 서비스는 이용 가능 / 설정 변경 막아야 하는지 확인 필요 -->
            <h4 class="lead">* The agent's settings are kept until approval and cannot be recovered after approval.</h4>
            <h4 class="lead">* If you request a stop, you will no longer be charged.</h4>
            <h4 class="lead">* Cancel about <a href="#" @click="signout_cancel">"Request to stop and Leave the service"</a></h4>
            <hr>
            <b-button :disabled="status.approve" class="text-left" variant="danger" @click="notice">STEP.2 If there is no problem after review, a normal cancellation and reminder will be sent to you. We can't restore it afterwards.</b-button>
            <br>
            <br>
            <h4 class="lead">* The service in use is stopped.</h4>
            <h4 class="lead">* You can receive email instructions on the results of your approval results </h4>
            <h4 class="lead">* The agent's settings are kept until approval and cannot be recovered after approval.</h4>
          </b-jumbotron>
          <hr>
        </div>
      </b-tab>
      <!-- 액션 로그 -->
      <b-tab title="Action Log">
        <actionList v-if="model.id" :group_id="model.id" />
      </b-tab>
    </b-tabs>
    <b-modal :title="modal.title"  class="modal-warning" v-model="modal.confirm" @ok="remove" ok-variant="warning">
     {{modal.msg || 'are you sure apply this?'}}
    </b-modal>
    <b-modal size="xl" title="Syslog format explain"  class="modal-info" v-model="modal.explain" ok-variant="success" ok-only hide-footer>
      <h4>Rsyslog format</h4>
      <b-table class="table_add table-striped" hover :items="log_format" :fields="['Fields', 'Value']"></b-table>
      <h4 class="title">Message Detail Format</h4>
      <hr>
      <h4 class="title_sub">
        WebCastle
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|[SourceIP]|[DestinationIP]|[ServerName]|Group:[groupname]|Direction:[SourceIP:SourcePORT]->[sourceIp:DestinationIP]|Risk:[risk]|Message:[PolicyName]|Host:[header's Host]|URI:URI Information]|Action:[block|detect]|Policy:[PolicyID]:[PolicyDetailInformation]
      </pre>
      <p class="col-form-label">Sample Detect or Block</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|158.247.215.235|35.84.178.246|vultr.guest1|Group:huni0213|Direction:35.84.178.246:58030->t1.com:80|Risk:Alert|Message:Host header is a numeric IP address|Host:158.247.215.235|URI:/.noindex.html|Action:block|Policy:[920350]Matched \"Operator `Rx' with parameter `^[\\d.:]+$' against variable `REQUEST_HEADERS:Host' (Value: `158.247.215.235' )"
      </pre>
      <p class="col-form-label">Sample Resource Alert or WAF Engine Down</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WAF|dev_06|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:Critical|Message:ResourceAlert|Host:dev_06|URI:-|Action:CPU 14%|Policy:CPU : 10 %

        WAF|158.247.215.235|35.84.178.246|vultr.guest1|Group:huni0213|Direction:-|Risk:Critical|Message:WAF was down|Host:vultr.guest1|URI:-|Action:-|Policy:-
      </pre>

      <h4 class="title_sub">
        WSFinder
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|[SourceIP]|[DestinationIP]|[ServerName]|Group:[groupname]|Direction:-|Risk:danger|Message:[forgery|detect]|Host:[ServerName]|URI:-]|Action:[Isolation|detect|forgery]|Policy:[PolicyInformation]
      </pre>
      <p class="col-form-label">Sample Detect or forgery</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|/var/www/html/webshell/php/itsec.php|dev_04|dev_04@172.17.0.12|Group:hdh_dev_01|Direction:-|Risk:danger|Message:Regex detected|Host:dev_04|URI:-|Action:detection|Policy:11

        WSFinder|1|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:danger|Message:forgery detected|Host:dev_06|URI:-|Action:forgery|Policy:[1]:/var/www
      </pre>
      <p class="col-form-label">Sample Resource Alert</p>
      <pre class="form-control" style="font-size: 14px !important;">

        WSFinder|dev_06|dev_06|dev_06@172.17.0.10|Group:hdh_dev_01|Direction:-|Risk:Critical|Message:ResourceAlert|Host:dev_06|URI:-|Action:CPU 14%|Policy:CPU : 10 %
      </pre>

      <h4 class="title_sub">
        WMDS
      </h4>
      <pre class="form-control" style="font-size: 14px !important;">

        WMDS|[대상URL]|[wmds.agent]|[Site Name]|Group:[groupname]|Direction:-|Risk:[Risk]|Message:[Detection classification]|Host:[FQDN|URL]|URI:-]|Action:[detect|forgery]|Policy:[Evidence for detection]
      </pre>
      <p class="col-form-label">Sample Detect or forgery</p>
      <pre class="form-control" style="font-size: 14px !important;">
        <!-- detect -->
        WMDS|http://f1security.co.kr|wmds.agent|f1security|Group:hdh_dev_01|Direction:-|Risk:danger|Message:malware detected|Host:dev_06|URI:-|Action:detect|Policy:f1security_policy_scan_daily
        <!-- forgery -->
        WMDS|http://f1security.co.kr|wmds.agent|f1security|Group:hdh_dev_01|Direction:-|Risk:danger|Message:forgery detected|Host:dev_06|URI:-|Action:forgery|Policy:/var/www
      </pre>

      <!-- <b-table hover :items="log_format_case" :fields="['Type', 'Attacker', 'Victim(Target)', 'Name',  'Action']"></b-table> -->
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="modal.explain = false">Close</button>
      </div>
     </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>

<!-- Direction:{reportData.client_ip}:{reportData.client_port}->{reportData.host_ip}:{reportData.host_port}|Risk:{min_risk}|Message:{reportData.messages.message}|Host:{log.host}|URI:{log.uri}|Action:{((bool)log?.is_block ? "block" : "detection")}|Policy:[{reportData.messages.details.ruleId}]{reportData.messages.details.match.ToString()}" -->
